// Fungsi bersama penyusun ronde semua mapel.
import { shuffle } from '../core/random.js';

// Salin soal bank dan acak urutan pilihannya (kecuali acakPilihan: false).
// Alasan per pilihan (why) ikut diacak supaya tetap berpasangan dengan pilihannya.
export function siapkanSoalBank(b) {
  const q = JSON.parse(JSON.stringify(b));
  if (q.acakPilihan === false) return q;
  if (q.type === 'pg') {
    const idx = shuffle(q.options.map((_, i) => i));
    q.options = idx.map(i => b.options[i]);
    if (Array.isArray(b.why)) q.why = idx.map(i => b.why[i] ?? '');
    q.answer = idx.indexOf(b.answer);
  } else if (q.type === 'mcma') {
    q.options = shuffle(q.options);
  }
  return q;
}
